// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__3yq8_","slider":"Toggle_slider__1_tFK"};